<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content">
            <div class="vs-row">
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ad"
                    title="ad"
                    id="ad"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ae"
                    title="ae"
                    id="ae"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-af"
                    title="af"
                    id="af"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ag"
                    title="ag"
                    id="ag"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ai"
                    title="ai"
                    id="ai"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-al"
                    title="al"
                    id="al"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-am"
                    title="am"
                    id="am"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ao"
                    title="ao"
                    id="ao"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-aq"
                    title="aq"
                    id="aq"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ar"
                    title="ar"
                    id="ar"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-as"
                    title="as"
                    id="as"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-at"
                    title="at"
                    id="at"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-au"
                    title="au"
                    id="au"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-aw"
                    title="aw"
                    id="aw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ax"
                    title="ax"
                    id="ax"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-az"
                    title="az"
                    id="az"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ba"
                    title="ba"
                    id="ba"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bb"
                    title="bb"
                    id="bb"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bd"
                    title="bd"
                    id="bd"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-be"
                    title="be"
                    id="be"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bf"
                    title="bf"
                    id="bf"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bg"
                    title="bg"
                    id="bg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bh"
                    title="bh"
                    id="bh"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bi"
                    title="bi"
                    id="bi"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bj"
                    title="bj"
                    id="bj"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bl"
                    title="bl"
                    id="bl"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bm"
                    title="bm"
                    id="bm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bn"
                    title="bn"
                    id="bn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bo"
                    title="bo"
                    id="bo"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bq"
                    title="bq"
                    id="bq"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-br"
                    title="br"
                    id="br"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bs"
                    title="bs"
                    id="bs"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bt"
                    title="bt"
                    id="bt"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bv"
                    title="bv"
                    id="bv"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bw"
                    title="bw"
                    id="bw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-by"
                    title="by"
                    id="by"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-bz"
                    title="bz"
                    id="bz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ca"
                    title="ca"
                    id="ca"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cc"
                    title="cc"
                    id="cc"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cd"
                    title="cd"
                    id="cd"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cf"
                    title="cf"
                    id="cf"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cg"
                    title="cg"
                    id="cg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ch"
                    title="ch"
                    id="ch"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ci"
                    title="ci"
                    id="ci"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ck"
                    title="ck"
                    id="ck"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cl"
                    title="cl"
                    id="cl"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cm"
                    title="cm"
                    id="cm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cn"
                    title="cn"
                    id="cn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-co"
                    title="co"
                    id="co"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cr"
                    title="cr"
                    id="cr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cu"
                    title="cu"
                    id="cu"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cv"
                    title="cv"
                    id="cv"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cw"
                    title="cw"
                    id="cw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cx"
                    title="cx"
                    id="cx"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cy"
                    title="cy"
                    id="cy"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-cz"
                    title="cz"
                    id="cz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-de"
                    title="de"
                    id="de"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-dj"
                    title="dj"
                    id="dj"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-dk"
                    title="dk"
                    id="dk"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-dm"
                    title="dm"
                    id="dm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-do"
                    title="do"
                    id="do"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-dz"
                    title="dz"
                    id="dz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ec"
                    title="ec"
                    id="ec"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ee"
                    title="ee"
                    id="ee"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-eg"
                    title="eg"
                    id="eg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-eh"
                    title="eh"
                    id="eh"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-er"
                    title="er"
                    id="er"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-es"
                    title="es"
                    id="es"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-et"
                    title="et"
                    id="et"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-fi"
                    title="fi"
                    id="fi"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-fj"
                    title="fj"
                    id="fj"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-fk"
                    title="fk"
                    id="fk"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-fm"
                    title="fm"
                    id="fm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-fo"
                    title="fo"
                    id="fo"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-fr"
                    title="fr"
                    id="fr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ga"
                    title="ga"
                    id="ga"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gb"
                    title="gb"
                    id="gb"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gd"
                    title="gd"
                    id="gd"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ge"
                    title="ge"
                    id="ge"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gf"
                    title="gf"
                    id="gf"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gg"
                    title="gg"
                    id="gg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gh"
                    title="gh"
                    id="gh"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gi"
                    title="gi"
                    id="gi"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gl"
                    title="gl"
                    id="gl"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gm"
                    title="gm"
                    id="gm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gn"
                    title="gn"
                    id="gn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gp"
                    title="gp"
                    id="gp"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gq"
                    title="gq"
                    id="gq"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gr"
                    title="gr"
                    id="gr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gs"
                    title="gs"
                    id="gs"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gt"
                    title="gt"
                    id="gt"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gu"
                    title="gu"
                    id="gu"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gw"
                    title="gw"
                    id="gw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gy"
                    title="gy"
                    id="gy"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-hk"
                    title="hk"
                    id="hk"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-hm"
                    title="hm"
                    id="hm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-hn"
                    title="hn"
                    id="hn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-hr"
                    title="hr"
                    id="hr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ht"
                    title="ht"
                    id="ht"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-hu"
                    title="hu"
                    id="hu"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-id"
                    title="id"
                    id="id"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ie"
                    title="ie"
                    id="ie"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-il"
                    title="il"
                    id="il"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-im"
                    title="im"
                    id="im"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-in"
                    title="in"
                    id="in"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-io"
                    title="io"
                    id="io"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-iq"
                    title="iq"
                    id="iq"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ir"
                    title="ir"
                    id="ir"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-is"
                    title="is"
                    id="is"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-it"
                    title="it"
                    id="it"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-je"
                    title="je"
                    id="je"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-jm"
                    title="jm"
                    id="jm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-jo"
                    title="jo"
                    id="jo"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-jp"
                    title="jp"
                    id="jp"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ke"
                    title="ke"
                    id="ke"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-kg"
                    title="kg"
                    id="kg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-kh"
                    title="kh"
                    id="kh"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ki"
                    title="ki"
                    id="ki"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-km"
                    title="km"
                    id="km"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-kn"
                    title="kn"
                    id="kn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-kp"
                    title="kp"
                    id="kp"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-kr"
                    title="kr"
                    id="kr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-kw"
                    title="kw"
                    id="kw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ky"
                    title="ky"
                    id="ky"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-kz"
                    title="kz"
                    id="kz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-la"
                    title="la"
                    id="la"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-lb"
                    title="lb"
                    id="lb"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-lc"
                    title="lc"
                    id="lc"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-li"
                    title="li"
                    id="li"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-lk"
                    title="lk"
                    id="lk"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-lr"
                    title="lr"
                    id="lr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ls"
                    title="ls"
                    id="ls"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-lt"
                    title="lt"
                    id="lt"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-lu"
                    title="lu"
                    id="lu"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-lv"
                    title="lv"
                    id="lv"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ly"
                    title="ly"
                    id="ly"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ma"
                    title="ma"
                    id="ma"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mc"
                    title="mc"
                    id="mc"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-md"
                    title="md"
                    id="md"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-me"
                    title="me"
                    id="me"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mf"
                    title="mf"
                    id="mf"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mg"
                    title="mg"
                    id="mg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mh"
                    title="mh"
                    id="mh"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mk"
                    title="mk"
                    id="mk"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ml"
                    title="ml"
                    id="ml"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mm"
                    title="mm"
                    id="mm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mn"
                    title="mn"
                    id="mn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mo"
                    title="mo"
                    id="mo"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mp"
                    title="mp"
                    id="mp"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mq"
                    title="mq"
                    id="mq"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mr"
                    title="mr"
                    id="mr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ms"
                    title="ms"
                    id="ms"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mt"
                    title="mt"
                    id="mt"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mu"
                    title="mu"
                    id="mu"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mv"
                    title="mv"
                    id="mv"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mw"
                    title="mw"
                    id="mw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mx"
                    title="mx"
                    id="mx"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-my"
                    title="my"
                    id="my"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-mz"
                    title="mz"
                    id="mz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-na"
                    title="na"
                    id="na"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-nc"
                    title="nc"
                    id="nc"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ne"
                    title="ne"
                    id="ne"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-nf"
                    title="nf"
                    id="nf"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ng"
                    title="ng"
                    id="ng"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ni"
                    title="ni"
                    id="ni"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-nl"
                    title="nl"
                    id="nl"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-no"
                    title="no"
                    id="no"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-np"
                    title="np"
                    id="np"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-nr"
                    title="nr"
                    id="nr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-nu"
                    title="nu"
                    id="nu"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-nz"
                    title="nz"
                    id="nz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-om"
                    title="om"
                    id="om"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pa"
                    title="pa"
                    id="pa"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pe"
                    title="pe"
                    id="pe"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pf"
                    title="pf"
                    id="pf"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pg"
                    title="pg"
                    id="pg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ph"
                    title="ph"
                    id="ph"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pk"
                    title="pk"
                    id="pk"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pl"
                    title="pl"
                    id="pl"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pm"
                    title="pm"
                    id="pm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pn"
                    title="pn"
                    id="pn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pr"
                    title="pr"
                    id="pr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ps"
                    title="ps"
                    id="ps"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pt"
                    title="pt"
                    id="pt"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-pw"
                    title="pw"
                    id="pw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-py"
                    title="py"
                    id="py"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-qa"
                    title="qa"
                    id="qa"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-re"
                    title="re"
                    id="re"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ro"
                    title="ro"
                    id="ro"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-rs"
                    title="rs"
                    id="rs"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ru"
                    title="ru"
                    id="ru"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-rw"
                    title="rw"
                    id="rw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sa"
                    title="sa"
                    id="sa"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sb"
                    title="sb"
                    id="sb"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sc"
                    title="sc"
                    id="sc"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sd"
                    title="sd"
                    id="sd"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-se"
                    title="se"
                    id="se"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sg"
                    title="sg"
                    id="sg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sh"
                    title="sh"
                    id="sh"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-si"
                    title="si"
                    id="si"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sj"
                    title="sj"
                    id="sj"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sk"
                    title="sk"
                    id="sk"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sl"
                    title="sl"
                    id="sl"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sm"
                    title="sm"
                    id="sm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sn"
                    title="sn"
                    id="sn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-so"
                    title="so"
                    id="so"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sr"
                    title="sr"
                    id="sr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ss"
                    title="ss"
                    id="ss"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-st"
                    title="st"
                    id="st"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sv"
                    title="sv"
                    id="sv"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sx"
                    title="sx"
                    id="sx"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sy"
                    title="sy"
                    id="sy"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-sz"
                    title="sz"
                    id="sz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tc"
                    title="tc"
                    id="tc"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-td"
                    title="td"
                    id="td"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tf"
                    title="tf"
                    id="tf"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tg"
                    title="tg"
                    id="tg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-th"
                    title="th"
                    id="th"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tj"
                    title="tj"
                    id="tj"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tk"
                    title="tk"
                    id="tk"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tl"
                    title="tl"
                    id="tl"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tm"
                    title="tm"
                    id="tm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tn"
                    title="tn"
                    id="tn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-to"
                    title="to"
                    id="to"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tr"
                    title="tr"
                    id="tr"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tt"
                    title="tt"
                    id="tt"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tv"
                    title="tv"
                    id="tv"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tw"
                    title="tw"
                    id="tw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-tz"
                    title="tz"
                    id="tz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ua"
                    title="ua"
                    id="ua"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ug"
                    title="ug"
                    id="ug"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-um"
                    title="um"
                    id="um"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-us"
                    title="us"
                    id="us"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-uy"
                    title="uy"
                    id="uy"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-uz"
                    title="uz"
                    id="uz"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-va"
                    title="va"
                    id="va"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-vc"
                    title="vc"
                    id="vc"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ve"
                    title="ve"
                    id="ve"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-vg"
                    title="vg"
                    id="vg"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-vi"
                    title="vi"
                    id="vi"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-vn"
                    title="vn"
                    id="vn"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-vu"
                    title="vu"
                    id="vu"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-wf"
                    title="wf"
                    id="wf"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ws"
                    title="ws"
                    id="ws"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-ye"
                    title="ye"
                    id="ye"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-yt"
                    title="yt"
                    id="yt"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-za"
                    title="za"
                    id="za"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-zm"
                    title="zm"
                    id="zm"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-zw"
                    title="zw"
                    id="zw"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-eu"
                    title="eu"
                    id="eu"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gb-eng"
                    title="gb-eng"
                    id="gb-eng"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gb-sct"
                    title="gb-sct"
                    id="gb-sct"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-gb-wls"
                    title="gb-wls"
                    id="gb-wls"
                  ></div></div
              ></vs-col>
              <vs-col vs-lg="1" vs-sm="2" vs-xs="3"
                ><div class="flag-wrapper">
                  <div
                    class="img-thumbnail flag flag-icon-background flag-icon-un"
                    title="un"
                    id="un"
                  ></div></div
              ></vs-col>
            </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>
